import EmpNotesPage from "../Employee/EmpNotesPage";
import api from "../../services/api";

function ITANotesPg() {
  return (
    <EmpNotesPage
      notesApi={{
        getNotes: api.getITNotes,
        addNote: api.addITNote,
        updateNote: api.updateITNote,
        deleteNote: api.deleteITNote
      }}
    />
  );
}

export default ITANotesPg;
